import React from "react";
import {InputJson} from "../../../nq-component";
import FollowUpFormPresenter from "./FollowUpFormPresenter";
import {getObjectUseCase, upsertUseCase} from '../../../usecases/object';
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import NavBar from "../../../components/navbar";
import FormFactory from "../../../components/FormFactory";

class FollowUpFormPage extends BaseFormPage {
    constructor(props) {
        super(props);
        this.state = {object: {}, inq: "", advanced: false};
        this.presenter = new FollowUpFormPresenter(this, getObjectUseCase(), upsertUseCase());
    }

    getCollectionName() {
        return "followUp"
    }

    getObjectId() {
        return undefined
    }

    componentDidMount() {
    const id = this.getObjectId()
    if (!id) {
        const inquiryId = this.props.params?.inquiryId
        this.setState({ inq: inquiryId })

        getObjectUseCase().execute("inquiries", inquiryId, {
            params: { include: ["client"] }
        }).then((inquiry) => {
            const clientEmail = inquiry?.client?.email_address;
            if (clientEmail) {
                console.log("Fetched client email:", clientEmail);
                this.setState(prev => ({
                    object: {
                        ...prev.object,
                        email_address: clientEmail
                    }
                }));
            }
        }).catch((err) => {
            console.error("Error fetching client email:", err);
        });

        getObjectUseCase().execute("inquiries", inquiryId, {
            params: { include: ["client"] }
        }).then((inquiry) => {
            const clientName = inquiry?.client?.name 
            if (clientName) {
                console.log("Fetched client name:", clientName)
                this.setState(prev => ({
                    object: {
                        ...prev.object,
                        name: clientName
                    }
                }))
            }
        }).catch((err) => {
            console.error("Error fetching client name:", err)
        })

        if (inquiryId) {
            this.setState({
                object: {
                    ...this.state.object,
                    inquiry: {
                        id: inquiryId
                    }
                }
            }, () => {
                super.componentDidMount()
            })
            return
        }
    }
    super.componentDidMount()
}


    onClickAdvance() {
        this.setState({advanced: !this.state.advanced});
    }

    render() {
        const object = this.state.object;
        const advanced = this.state.advanced;
        const schema = this.getSchema(this.getCollectionName());
        if (!schema) return <h1>no schema</h1>;
        const label = this.getObjectId() === undefined ? "Add New " : "Edit ";
        return (
            <>
                <NavBar
                    action={() => (
                        <div className="dropdown dropstart d-inline-block">
                            <i role="button" data-bs-toggle="dropdown" className="bi bi-three-dots-vertical"></i>
                            <div className="dropdown-menu fs-xs">
                                <button
                                    onClick={this.onClickAdvance.bind(this)}
                                    className="dropdown-item py-3">
                                    <i className='bi bi-gear pe-2'/>Toggle Advance
                                </button>
                            </div>
                        </div>
                    )}/>
                <div className="overflow-auto">
                    <div className="h-100">
                        <div className="p-3 p-lg-4">
                            <div className="d-flex align-items-start mt-3">
                            <i className="bi bi-chevron-left" style={{ fontSize: '1.5rem' }} onClick={this.onClickBack.bind(this)}></i>
                            <h1 className="fw-bold text-capitalize"> {label + (schema.label || "Follow Up")}</h1>
                            </div>
                            <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                                <form onSubmit={this.onSubmitForm.bind(this)}>
                                    <div className="row g-3">
                                        {
                                            advanced
                                                ?
                                                <InputJson
                                                    defaultValue={object}
                                                    onChange={this.onChange.bind(this)}
                                                    rows="15"/>
                                                :
                                                <FormFactory
                                                    schema={schema}
                                                    object={object}
                                                    onChange={this.onChange.bind(this)}
                                                    excludeFields={"inquiry"}/>
                                        }
                                    </div>
                                    <div className="mt-4 d-flex justify-content-center">
                                        <button type="button" className="btn btn-light fs-sm me-3 w-50 fw-bolder"
                                                onClick={this.onClickBack.bind(this)}>Cancel
                                        </button>
                                        <button type="submit" className="btn btn-primary fs-sm w-50 fw-bolder text-black">
                                                Send
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(FollowUpFormPage);
